import { Button, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SpacingRow, SpacingUnit } from 'components/ui';
import { useEditFormStore } from 'stores/local';

const EditFormButtonNodes: React.FC = () => {
  const { t } = useTranslation();
  const { editFormStore } = useEditFormStore();

  const reset = React.useCallback(() => {
    editFormStore.resetChanges();
  }, [editFormStore]);

  const handleContinue = React.useCallback(async () => {
    await editFormStore.handleContinue();
  }, [editFormStore]);

  const handleSave = React.useCallback(async () => {
    await editFormStore.handleSave();
  }, [editFormStore]);

  const buttonNode = React.useMemo(() => {
    return (
      <Button
        disabled={editFormStore.continueButtonDisabled.disabled}
        key="03"
        onClick={handleContinue}
      >
        {t('common.continue')}
      </Button>
    );
  }, [editFormStore.continueButtonDisabled.disabled, handleContinue]);

  const cancelDisabled = !editFormStore.formStore.isDataChanged;
  const saveDisabled = !editFormStore.formStore.isDataChanged;
  const formUpdateLoading = editFormStore.formStore.formUpdateRequest.loading;

  return (
    <SpacingRow hSpacing={SpacingUnit.unit2}>
      <Button
        disabled={cancelDisabled}
        loading={!cancelDisabled && formUpdateLoading}
        onClick={reset}
      >
        {t('common.cancel')}
      </Button>
      <Button
        disabled={saveDisabled}
        loading={!saveDisabled && formUpdateLoading}
        onClick={handleSave}
      >
        {t('common.save')}
      </Button>
      {editFormStore.continueButtonDisabled ? (
        <Tooltip title={editFormStore.continueButtonDisabled.text}>
          {buttonNode}
        </Tooltip>
      ) : (
        buttonNode
      )}
    </SpacingRow>
  );
};

export default observer(EditFormButtonNodes);
